import React, { Component } from "react";
import { getGeoInfo, utmTracking, Getotp, onboardLoginOTP } from "../../Model/Users"; //Include Home
import "./Signup.css";
import Signupscreen1 from "./Signupscreen1";
import { Encrypt, withRouter, VirsionCheck, Faq, makeid, extractUTMParams } from "../../Helpers/Common"; //Include Home
import { Metadata } from "../Metadata/Metadata";
import BarLoader from "react-spinners/BarLoader";

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        fld_mobile: "",
        country_code: "+251",
        fld_password: "",
        otp: "",
      },
      errors: {
        isValidEmailerror: false,
        isValidMobileerror: false,
        isValidPassworderror: false,
      },
      msg: {
        alreadyRegiter: false,
        validpasswordMsg: false,
        validcredentials: false,
      },
      show: true,
      isValidEmail: false,
      isValidMobile: false,
      isValidPassword: false,
      isSignUpExist: false,
      isSignInExist: false,
      is_exist: false,
      isShow: false,
      Redirect: false,
      VirsionCheckData: [],
      Faqdata: [],
      Focus: "",
      VirsionCheckDataloaded: false,
      showpassword: false,
      otperror: false,
      otpErrorMsg: '',
      OTPsuccess: '',
      NotSubscribed: '',
      OtpNotFoundMsg: '',
      NumberNotFoundMsg: '',
      userNotFound: false,
      OtpNotFound: false,
      NumberNotFound: false,
      invalidOTP: false,
      invalidOTPMsg: '',
      MaxLogin: false,
      MaxLoginMsg: '',
      NotSubscribe: false,
      NotSubscribeMsg: '',
      invalidData: false,
      invalidDataMsg: '',
      country: "",
      showButton: false,
    };
    this.handler = this.handler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submituserRegistrationForm = this.submituserRegistrationForm.bind(this);
  }

  async componentDidMount() {
    const currentURL = window.location.href;
    if (currentURL.includes("utm_source")) {
      const extractUTMParamsResp = await extractUTMParams(currentURL);
      if (
        extractUTMParamsResp.utmSource !== "" &&
        extractUTMParamsResp.utmMedium !== "" &&
        extractUTMParamsResp.utmCampaign !== "" &&
        extractUTMParamsResp.click_id !== ""
      ) {
        let utmLocalValidation = localStorage.getItem("utmTrack");
        let data = {
          utmTracking: "without_signup",
          utm_details: {
            utmSource: extractUTMParamsResp.utmSource,
            utmMedium: extractUTMParamsResp.utmMedium,
            utmCampaign: extractUTMParamsResp.utmCampaign,
            click_id: extractUTMParamsResp.click_id,
          },
        };
        utmTracking(data).then((res) => {
          let resData = JSON.parse(res.data);
          localStorage.setItem("utmTrack", resData?.data?.track_id);
          if (data["utm_details"]["click_id"]) {
            localStorage.setItem("click_id", data["utm_details"]["click_id"]);
            localStorage.setItem("utmSource", data["utm_details"]["utmSource"]);
          }
        });
      }
    }
    // }
    getGeoInfo().then((res) => {
      this.setState({
        country: res,
      });
      localStorage.setItem("country", res);
    });
    VirsionCheck().then((vcheckres) => {
      Faq().then((faqres) => {
        this.setState({
          VirsionCheckData: vcheckres,
          VirsionCheckDataloaded: true,
          Faqdata: faqres,
        });
      });
      if (localStorage.getItem("SessId") == null) {
        makeid(15).then((res) => {
          localStorage.setItem("SessId", res);
        });
      }
    });
  }

  Showpassword() {
    var checkcurrentState = this.state.showpassword;
    if (checkcurrentState) {
      this.setState({
        showpassword: false,
      });
    } else {
      this.setState({
        showpassword: true,
      });
    }
  }

  GetOTP() {
    if (this.state.fields.fld_mobile != "") {
      var postdata = {
        fld_mobile: this.state.fields.fld_mobile,
        countryCode: this.state.fields.country_code,
      };

      if (postdata.fld_mobile.startsWith("0")) {
        postdata.fld_mobile = postdata.fld_mobile.substring(1);
      }
      Getotp(postdata).then((res) => {
        var responseData = JSON.parse(res.data.body)
        if (responseData) {
          if (responseData.success == true) {
            this.setState({
              userNotFound: true,
              OTPsuccess: responseData.msg,
            })
            setTimeout(() => {
              this.setState({
                userNotFound: false,
                OTPsuccess: '',
                NotSubscribed: '',
              })
            }, 2000)
          } else {
            this.setState({
              NotSubscribe: true,
              NotSubscribeMsg: responseData.message,
            })
            setTimeout(() => {
              this.setState({
                NotSubscribe: false,
                NotSubscribeMsg: ""
              })
            }, 2000)
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({
        otperror: true,
        otpErrorMsg: "Mobile number can not be blank"
      })
      setTimeout(() => {
        this.setState({
          otperror: false,
          otpErrorMsg: '',
        })
      }, 2000)
    }
  }

  handler() {
    this.setState({
      someVar: "some value",
    });
  }

  handleChange(e) {
    const fields = this.state.fields;
    var setMsg = this.state.msg;
    setMsg["validcredentials"] = false;
    this.setState({ setMsg });
    var errorState = this.state.errors;
    errorState["isValidEmailerror"] = false;
    errorState["isValidPassworderror"] = false;
    errorState["isValidMobileerror"] = false;
    this.setState({ errorState });
    var Valuespost = e.target.name;
    if (e.target.name == "fld_email") {
      const isValid = this.state.isValid;
      // const emailRegex = /\S+@\S+\.\S+/;
      const emailRegex = /\S+@\S+\.\S{2,}/;
      //Set State For Valid email
      var errorState = this.state.errors;
      errorState["isValidEmailerror"] = false;
      this.setState({ errorState });
      if (emailRegex.test(e.target.value)) {
        this.checkUserByNumberorEmail("fld_email", e.target.value);
        this.setState({
          isValidEmail: true,
          showButton: true,
          isSignUpExist: false,
        });
      } else {
        this.setState({
          isValidEmail: false,
          showButton: false,
          isSignUpExist: true,
        });
      }
    } else if (e.target.name == "fld_password") {
      const isValidPassword = this.state.isValidPassword;
      if (e.target.value.length >= 6 && e.target.value.length <= 60) {
        var validPasswordMsg = this.state.msg;
        // validPasswordMsg["validpasswordMsg"] = true;
        errorState["isValidPassworderror"] = false;
        this.setState({
          isValidPassword: true,
          errorState,
          validPasswordMsg,
        });
      } else {
        var validPasswordMsg = this.state.msg;
        validPasswordMsg["validpasswordMsg"] = false;
        this.setState({
          isValidPassword: false,
          validPasswordMsg,
        });
      }
    } else if (e.target.name == "fld_mobile" && /\s/.test(e.target.value) == false) {
      const isValidMobile = this.state.isValidMobile;
      var errorState = this.state.errors;
      errorState["isValidMobileerror"] = false;
      this.setState({ errorState });
      if (e.target.value.length >= 6 && e.target.value.length <= 50 && !isNaN(e.target.value)) {
        // this.checkUserByNumberorEmail("fld_mobile", e.target.value);
        this.setState({
          isValidMobile: true,
          showButton: false,
          // isSignInExist: true/,
          isSignUpExist: false,
        });
      } else {
        this.setState({
          isValidMobile: false,
          showButton: false,
          // isSignInExist: false,
          isSignUpExist: true,
        });
      }
    }

    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }

  backbutton() {
    const fields = this.state.fields;
    fields["fld_password"] = "";
    var validPasswordMsg = this.state.msg;
    validPasswordMsg["validpasswordMsg"] = false;
    this.setState({
      show: true,
      fields,
      isValidPassword: false,
      validPasswordMsg,
    });
  }

  handleFocus = () => {
    this.setState({ EmailFocus: "active-border", showButton: true });
  };

  handleBlur = () => {
    this.setState({ isFocus: "no focus" });
  };

  submituserRegistrationForm(e) {
    e.preventDefault();
    var postdata = {
      fld_mobile: this.state.fields.fld_mobile,
      countryCode: this.state.fields.country_code,
      otp: this.state.fields.otp,
      device: navigator.userAgent,
    };
    if (this.state.fields.fld_mobile == "" && this.state.fields.otp == "") {
      this.setState({
        OtpNotFound: true,
        OtpNotFoundMsg: "Please enter OTP",
        NumberNotFound: true,
        NumberNotFoundMsg: "Mobile number can not be blank",
      })
      setTimeout(() => {
        this.setState({
          OtpNotFound: false,
          OtpNotFoundMsg: '',
          NumberNotFound: false,
          NumberNotFoundMsg: '',
        })
      }, 2000)
      return
    } else if (this.state.fields.otp == "") {
      this.setState({
        OtpNotFound: true,
        OtpNotFoundMsg: "Please enter OTP",
      })
      setTimeout(() => {
        this.setState({
          OtpNotFound: false,
          OtpNotFoundMsg: '',
        })
      }, 2000)
      return
    } else if (this.state.fields.fld_mobile == "") {
      this.setState({
        NumberNotFound: true,
        NumberNotFoundMsg: "Mobile number can not be blank",
      })
      setTimeout(() => {
        this.setState({
          NumberNotFound: false,
          NumberNotFoundMsg: '',
        })
      }, 2000)
      return
    } else {
      // var postdata = {
      //   fld_mobile: this.state.fields.fld_mobile,
      //   countryCode: this.state.fields.country_code,
      //   otp: this.state.fields.otp,
      // };
      if (postdata.fld_mobile.startsWith("0")) {
        postdata.fld_mobile = postdata.fld_mobile.substring(1);
      }
      onboardLoginOTP(postdata).then((res) => {
        var SuccessResponse = JSON.parse(res.data.body);
        var mobileCountryCode = this.state.fields.country_code;
        mobileCountryCode = mobileCountryCode.replace("+", "");
        // common.Call("token/create", "POST", requestBody, function(err, resp ){
        //     res.header('Access-Control-Allow-Credentials', 'true');
        // })
        var msisdn = mobileCountryCode + postdata.fld_mobile
        localStorage.setItem("userID", SuccessResponse?.userID);
        localStorage.setItem("session_id", SuccessResponse?.session_id);
        localStorage.setItem("msisdn", msisdn);
        localStorage.setItem("is_child_local_storage", SuccessResponse?.is_child);
        if (res.data) {
          if (JSON.parse(res.data.body).success == true) {
            Encrypt(JSON.parse(res.data.body)).then((res) => {
              localStorage.setItem("user-info", JSON.stringify(res));
              this.setState({
                logindetails: res,
                formSubmitted: true,
              });
              this.setState({
                Redirect: true,
              });
              this.props.navigate("/");
            });
          } else {
            if (SuccessResponse.errorcode == 1148) {
              this.setState({
                invalidOTP: true,
                invalidOTPMsg: SuccessResponse.message,
              })
              setTimeout(() => {
                this.setState({
                  invalidOTP: false,
                  invalidOTPMsg: "",
                })
              }, 2000)
            } else if (SuccessResponse.errorcode == 1147) {
              this.setState({
                MaxLogin: true,
                MaxLoginMsg: SuccessResponse.message,
              })
              setTimeout(() => {
                this.setState({
                  MaxLogin: false,
                  MaxLoginMsg: ""
                })
              }, 2000)
            } else {
              this.setState({
                invalidData: true,
                invalidDataMsg: "Something went Wrong!",
              })
              setTimeout(() => {
                this.setState({
                  invalidData: false,
                  invalidDataMsg: ""
                })
              }, 2000)
            }
          }
        }
      });
    }
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      //  return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      if (
        (this.state.isValidEmail && this.state.isValidPassword) ||
        (this.state.isValidMobile && this.state.isValidPassword)
      ) {
        var enable = false;
      } else {
        var enable = true;
      }

      if (this.state.isValidEmail) {
        var fld_email = false;
        var fld_mobile = true;
      } else if (this.state.isValidMobile) {
        var fld_email = true;
        var fld_mobile = false;
      } else {
        var fld_email = false;
        var fld_mobile = false;
      }

      if (this.state.isValidEmail || this.state.isValidMobile) {
        var fenable = false;
        if (this.state.isValidEmail && this.state.isValidMobile) {
          var fenable = true;
        } else {
          var fenable = false;
        }
      } else {
        var fenable = true;
      }

      var MetaData = JSON.parse(this.state.VirsionCheckData.data).data.page.signup;

      return (
        <div>
          <Metadata page="CREATEACCOUNT" />

          <form
            className="login_form"
            method="post"
            name="loginformidv2"
            onSubmit={this.submituserRegistrationForm}
            noValidate="novalidate"
          >
            <Signupscreen1 data={this} />
            {/* {this.state.hide ? <Signupscreen2 data={this} /> : null} */}
          </form>
        </div>
      );
    }
  }
}
export default withRouter(Signup);
